module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "rightPanel",
    attrs: {
      "datas": _vm.connects,
      "hideFooter": true
    },
    on: {
      "onClose": _vm.onClose
    }
  }, [_c('div', {
    staticClass: "project-header",
    slot: "header"
  }, [(_vm.connects) ? _c('span', {
    staticClass: "limit-text"
  }, [_c('translate', [_vm._v("Connect")]), _vm._v(_vm._s((" ( " + (_vm.connects.resourceName) + " )")))], 1) : _vm._e()]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading",
    slot: "content"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/loading.gif")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.m && _vm.m.os === 'linux') ? _c('div', {
    staticClass: "project-connect",
    slot: "content"
  }, [_c('div', {
    staticClass: "b-b"
  }, [_c('translate', [_vm._v("Verify Security")])], 1), _vm._v(" "), _c('div', {
    staticClass: "vertify-content"
  }, [(_vm.m.selectUserData) ? _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("The Way Of Verification")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), (_vm.m.selectUserData.auth_type === 0) ? _c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_c('translate', [_vm._v("Host Password")])], 1) : _vm._e(), _vm._v(" "), (_vm.m.selectUserData.auth_type === 1) ? _c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_vm._v("SSH KEY")]) : _vm._e(), _vm._v(" "), (_vm.m.selectUserData.auth_type === 2) ? _c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_c('translate', [_vm._v("CloudLinker team account password")])], 1) : _vm._e()], 1) : _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("The Way Of Verification")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), (_vm.m.resource.csos_check === 'open') ? _c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_c('translate', [_vm._v("CloudLinker team account password")])], 1) : _vm._e(), _vm._v(" "), (_vm.m.resource.csos_check === 'close' && _vm.m.resource.autologin === 1) ? _c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_vm._v("SSH KEY")]) : _vm._e(), _vm._v(" "), (_vm.m.resource.csos_check === 'close' && _vm.m.resource.autologin === 0) ? _c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_c('translate', [_vm._v("Host Password")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.m.safe.network_safe_mode) ? _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Security mode")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.m.safe.safe_mode_approver && _vm.safeMode),
      expression: "!m.safe.safe_mode_approver && safeMode"
    }],
    attrs: {
      "span": 4
    }
  }, [_c('translate', [_vm._v("Block")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.m.safe.safe_mode_approver && !_vm.safeMode),
      expression: "!m.safe.safe_mode_approver && !safeMode"
    }],
    attrs: {
      "span": 4
    }
  }, [_c('translate', [_vm._v("Green Light")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.m.safe.safe_mode_approver && _vm.safeMode && (_vm.m.safe.safe_mode_application == 3 || _vm.m.safe.safe_mode_application == 4)),
      expression: "m.safe.safe_mode_approver && safeMode && (m.safe.safe_mode_application == 3 || m.safe.safe_mode_application == 4)"
    }],
    attrs: {
      "span": 2
    }
  }, [_c('translate', [_vm._v("Block")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.m.safe.safe_mode_approver && _vm.safeMode && _vm.m.safe.safe_mode_application == 0),
      expression: "m.safe.safe_mode_approver && safeMode && m.safe.safe_mode_application == 0"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v("block/pending audit")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.m.safe.safe_mode_approver && _vm.safeMode && _vm.m.safe.safe_mode_application == 1),
      expression: "m.safe.safe_mode_approver && safeMode && m.safe.safe_mode_application == 1"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v("block/passed")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.m.safe.safe_mode_approver && _vm.safeMode && _vm.m.safe.safe_mode_application == 2),
      expression: "m.safe.safe_mode_approver && safeMode && m.safe.safe_mode_application == 2"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v("block/not passed")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.m.safe.safe_mode_approver && !_vm.safeMode && _vm.m.safe.safe_mode_application == 1),
      expression: "m.safe.safe_mode_approver && !safeMode && m.safe.safe_mode_application == 1"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('translate', [_vm._v("green light/passed")])], 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.m.safe.safe_mode_approver && _vm.safeMode && (_vm.m.safe.safe_mode_application == 3 || _vm.m.safe.safe_mode_application == 4)),
      expression: "m.safe.safe_mode_approver && safeMode && (m.safe.safe_mode_application == 3 || m.safe.safe_mode_application == 4)"
    }],
    staticClass: "apply-safe",
    attrs: {
      "span": 6
    },
    on: {
      "click": _vm.startApply
    }
  }, [_c('translate', [_vm._v("Apply Non-security mode")])], 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.m.safe.safe_mode_approver || (_vm.m.safe.safe_mode_approver && _vm.m.safe.safe_mode_application == 1)),
      expression: "!m.safe.safe_mode_approver || (m.safe.safe_mode_approver && m.safe.safe_mode_application == 1)"
    }],
    attrs: {
      "span": 3
    },
    on: {
      "click": _vm.switchSafeMode
    }
  }, [_c('translate', [_vm._v("Switch")])], 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.m.safe.safe_mode_approver && _vm.safeMode && _vm.m.safe.safe_mode_application == 2),
      expression: "m.safe.safe_mode_approver && safeMode && m.safe.safe_mode_application == 2"
    }],
    staticClass: "apply-safe",
    attrs: {
      "span": 3
    },
    on: {
      "click": _vm.startApply
    }
  }, [_c('translate', [_vm._v("Reapply")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Default Username")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-select', {
    on: {
      "change": function($event) {
        _vm.changeUser()
      }
    },
    model: {
      value: (_vm.defaultUser),
      callback: function($$v) {
        _vm.defaultUser = $$v
      },
      expression: "defaultUser"
    }
  }, _vm._l((_vm.m.usernameList), function(option) {
    return _c('el-option', {
      key: option.id,
      attrs: {
        "label": option,
        "value": option
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "b-b b-t"
  }, [_c('translate', [_vm._v("Connection Information")])], 1), _vm._v(" "), _c('div', {
    staticClass: "vertify-content"
  }, [(_vm.agentUpdateTip) ? _c('p', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "el-icon-warning",
    staticStyle: {
      "color": "#fda541",
      "font-size": "14px",
      "top": "2px"
    }
  }), _vm._v(" "), _c('translate', {
    staticStyle: {
      "color": "#fda541"
    }
  }, [_vm._v("The cluster's agent verison is too low. Please remind the administrator to upgrade as soon as possible")])], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Host")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_vm._v(_vm._s(_vm.m.agent.host))]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.m.agent.host),
      expression: "m.agent.host",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    attrs: {
      "span": 3
    }
  }, [_c('a', [_c('translate', [_vm._v("Copy")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Port")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_vm._v(_vm._s(_vm.m.agent.ssh_port))]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (String(_vm.m.agent.ssh_port)),
      expression: "String(m.agent.ssh_port)",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    attrs: {
      "span": 3
    }
  }, [_c('a', [_c('translate', [_vm._v("Copy")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Username")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_vm._v(_vm._s(_vm.userName))]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.userName),
      expression: "userName",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    attrs: {
      "span": 3
    }
  }, [_c('a', [_c('translate', [_vm._v("Copy")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("IP Whitelist")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "ip-whitelist",
    attrs: {
      "span": 13
    }
  }, [_vm._l((_vm.getAllowIPList(_vm.m.allow_ip)), function(ip, ipIndex) {
    return _c('div', {
      key: ipIndex
    }, [_vm._v(_vm._s(ip))])
  }), _vm._v(" "), (!_vm.m.allow_ip) ? _c('span', [_vm._v("-")]) : _vm._e()], 2), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('a', {
    on: {
      "click": _vm.modifyCode
    }
  }, [_c('translate', [_vm._v("Change")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("SSH Command")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.ssh_link
    }
  }, [_vm._v(_vm._s(_vm.codeStr))])]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.codeStr),
      expression: "codeStr",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    attrs: {
      "span": 3
    }
  }, [_c('a', [_c('translate', [_vm._v("Copy")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Connect Username")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    staticClass: "linux-username",
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.defaultUser),
      callback: function($$v) {
        _vm.defaultUser = $$v
      },
      expression: "defaultUser"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    class: {
      safeConnect: !_vm.safeMode
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.connectHost($event)
      }
    }
  }, [_c('translate', [_vm._v("Connect")])], 1)], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.m && _vm.m.os === 'win32' && _vm.connects.agentVersion >= '2.4.0') ? _c('div', {
    staticClass: "project-connect",
    slot: "content"
  }, [_c('div', {
    staticClass: "b-b"
  }, [_c('translate', [_vm._v("Verify Security")])], 1), _vm._v(" "), _c('div', {
    staticClass: "vertify-content"
  }, [_c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("The Way Of Verification")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_c('translate', [_vm._v("Login to the host using the local password")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Default Username")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-select', {
    on: {
      "change": function($event) {
        _vm.changeUser()
      }
    },
    model: {
      value: (_vm.defaultUser),
      callback: function($$v) {
        _vm.defaultUser = $$v
      },
      expression: "defaultUser"
    }
  }, _vm._l((_vm.m.usernameList), function(option) {
    return _c('el-option', {
      key: option.id,
      attrs: {
        "label": option,
        "value": option
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "b-b b-t"
  }, [_c('translate', [_vm._v("Connection Information")])], 1), _vm._v(" "), _c('div', {
    staticClass: "vertify-content"
  }, [(_vm.agentUpdateTip) ? _c('p', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "el-icon-warning",
    staticStyle: {
      "color": "#fda541",
      "font-size": "14px",
      "top": "2px"
    }
  }), _vm._v(" "), _c('translate', {
    staticStyle: {
      "color": "#fda541"
    }
  }, [_vm._v("The cluster's agent verison is too low. Please remind the administrator to upgrade as soon as possible")])], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Host")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "p-l-15",
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.m.winHost))]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.m.winHost),
      expression: "m.winHost",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    attrs: {
      "span": 3
    }
  }, [_c('a', [_c('translate', [_vm._v("Copy")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Port")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "p-l-15",
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.m.agent.rdp_port))]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (String(_vm.m.agent.rdp_port)),
      expression: "String(m.agent.rdp_port)",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    attrs: {
      "span": 3
    }
  }, [_c('a', [_c('translate', [_vm._v("Copy")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Username")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "p-l-15",
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.userName))]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.userName),
      expression: "userName",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    attrs: {
      "span": 3
    }
  }, [_c('a', [_c('translate', [_vm._v("Copy")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("IP Whitelist")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "p-l-15 ip-whitelist",
    attrs: {
      "span": 12
    }
  }, [_vm._l((_vm.getAllowIPList(_vm.m.allow_ip)), function(ip, ipIndex) {
    return _c('div', {
      key: ipIndex
    }, [_vm._v(_vm._s(ip))])
  }), _vm._v(" "), (!_vm.m.allow_ip) ? _c('span', [_vm._v("-")]) : _vm._e()], 2), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('a', {
    on: {
      "click": _vm.modifyCode
    }
  }, [_c('translate', [_vm._v("Change")])], 1)])], 1), _vm._v(" "), (_vm.m.agent.webrdp_port) ? _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Connect Username")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    staticClass: "linux-username",
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.defaultUser),
      callback: function($$v) {
        _vm.defaultUser = $$v
      },
      expression: "defaultUser"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    class: {
      safeConnect: !_vm.safeMode
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.connectWinHost($event)
      }
    }
  }, [_c('translate', [_vm._v("Connect")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('translate', {
    staticClass: "text-center",
    attrs: {
      "tag": "h4"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.m && _vm.m.os === 'win32' && _vm.connects.agentVersion < '2.4.0') ? _c('div', {
    staticClass: "project-connect",
    slot: "content"
  }, [_c('div', {
    staticClass: "b-b"
  }, [_c('translate', [_vm._v("Connection Information")])], 1), _vm._v(" "), _c('div', {
    staticClass: "vertify-content"
  }, [(_vm.agentUpdateTip) ? _c('p', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "el-icon-warning",
    staticStyle: {
      "color": "#fda541",
      "font-size": "14px",
      "top": "2px"
    }
  }), _vm._v(" "), _c('translate', {
    staticStyle: {
      "color": "#fda541"
    }
  }, [_vm._v("The cluster's agent verison is too low. Please remind the administrator to upgrade as soon as possible")])], 1) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "l-h-36 text-center"
  }, [_c('translate', [_vm._v("Use the RDP client to connect to the current host")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center l-h-36"
  }, [_c('span', [_c('translate', [_vm._v("Please confirm")])], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://files.cloudcare.cn/rdpclient.exe"
    }
  }, [_c('translate', [_vm._v("download")])], 1), _vm._v(" "), _c('span', [_c('translate', [_vm._v("and installed the RDP client (Windows only support)")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-center l-h-36"
  }, [_c('translate', [_vm._v("Fill in the client with Code and connect to your Windows server.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "l-h-36 text-center"
  }, [_c('span', [_vm._v("Code")]), _vm._v(" "), _c('span', [_vm._v(":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.m.code))])]), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("IP Whitelist")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "p-l-15 ip-whitelist",
    attrs: {
      "span": 12
    }
  }, [_vm._l((_vm.getAllowIPList(_vm.m.allow_ip)), function(ip, ipIndex) {
    return _c('div', {
      key: ipIndex
    }, [_vm._v(_vm._s(ip))])
  }), _vm._v(" "), (!_vm.m.allow_ip) ? _c('span', [_vm._v("-")]) : _vm._e()], 2), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('a', {
    on: {
      "click": _vm.modifyCode
    }
  }, [_c('translate', [_vm._v("Change")])], 1)])], 1), _vm._v(" "), _c('img', {
    staticClass: "win-image",
    attrs: {
      "src": "/static/images/screen_windows.png",
      "alt": "demo"
    }
  })], 1), _vm._v(" "), _c('translate', {
    staticClass: "text-center",
    attrs: {
      "tag": "h4"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.m && (_vm.m.os === 'mysql' || _vm.m.os === 'mssql' || _vm.m.os === 'postgresql' || _vm.m.os === 'oracle')) ? _c('div', {
    staticClass: "project-connect",
    slot: "content"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/loading.gif")
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "b-b"
  }, [_c('translate', [_vm._v("Connection Information")])], 1), _vm._v(" "), _c('div', {
    staticClass: "vertify-content"
  }, [(_vm.agentUpdateTip) ? _c('p', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "el-icon-warning",
    staticStyle: {
      "color": "#fda541",
      "font-size": "14px",
      "top": "2px"
    }
  }), _vm._v(" "), _c('translate', {
    staticStyle: {
      "color": "#fda541"
    }
  }, [_vm._v("The cluster's agent verison is too low. Please remind the administrator to upgrade as soon as possible")])], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Host")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "p-l-15",
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.m.sqlHost))]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.m.sqlHost),
      expression: "m.sqlHost",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    attrs: {
      "span": 3
    }
  }, [_c('a', [_c('translate', [_vm._v("Copy")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Port")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "p-l-15",
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.m.sqlport))]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.m.sqlport),
      expression: "m.sqlport",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    attrs: {
      "span": 3
    }
  }, [_c('a', [_c('translate', [_vm._v("Copy")])], 1)])], 1), _vm._v(" "), (_vm.m.os === 'oracle') ? _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Connection identifier type")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "p-l-15",
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.m.serviceNameType === 'sid' ? 'SID' : 'Service Name'))])], 1) : _vm._e(), _vm._v(" "), (_vm.m.os === 'oracle') ? _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Service Name / SID")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "p-l-15",
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.m.serviceName))]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.m.serviceName),
      expression: "m.serviceName",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    attrs: {
      "span": 3
    }
  }, [_c('a', [_c('translate', [_vm._v("Copy")])], 1)])], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Username")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "p-l-15",
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.m.code))]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.m.code),
      expression: "m.code",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    attrs: {
      "span": 3
    }
  }, [_c('a', [_c('translate', [_vm._v("Copy")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("IP Whitelist")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "p-l-15 ip-whitelist",
    attrs: {
      "span": 12
    }
  }, [_vm._l((_vm.getAllowIPList(_vm.m.allow_ip)), function(ip, ipIndex) {
    return _c('div', {
      key: ipIndex
    }, [_vm._v(_vm._s(ip))])
  }), _vm._v(" "), (!_vm.m.allow_ip) ? _c('span', [_vm._v("-")]) : _vm._e()], 2), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('a', {
    on: {
      "click": _vm.modifyCode
    }
  }, [_c('translate', [_vm._v("Change")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Note:")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "p-l-15",
    attrs: {
      "span": 12
    }
  }, [(_vm.m.os === 'mysql') ? _c('translate', [_vm._v("Use MySQL client to connect to the current database")]) : _vm._e(), _vm._v(" "), (_vm.m.os === 'mssql') ? _c('translate', [_vm._v("Use SQL Server client to connect to the current database")]) : _vm._e(), _vm._v(" "), (_vm.m.os === 'postgresql') ? _c('translate', [_vm._v("Use PostgreSQL client to connect to the current database")]) : _vm._e(), _vm._v(" "), (_vm.m.os === 'oracle') ? _c('translate', [_vm._v("Oracle only supports web connections")]) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('a', {
    on: {
      "click": _vm.sqlConnect
    }
  }, [_c('translate', [_vm._v("Connect")])], 1)])], 1)], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c4d5008"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/operations/model/workgroup-connection.vue
// module id = 572
// module chunks = 4 5 6